import searchSVG from './search.svg';

const styles = (theme) => ({
  root: {},
  cardContent: {
    padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px ${
      theme.spacing.unit * 3
    }px ${theme.spacing.unit * 2}px`,
    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing.unit * 5}px ${theme.spacing.unit * 10}px ${
        theme.spacing.unit * 5
      }px`,
    },
  },
  gridItemRight: {
    textAlign: 'right',
  },
  label: {
    marginTop: theme.spacing.unit * 1.5,
    marginBottom: theme.spacing.unit * 1,
    fontWeight: 600,
    fontSize: '1.0625rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
  searchInput: {
    '&:placeholder-shown': {
      paddingLeft: 40,
      backgroundImage: `url('${searchSVG}')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: `${theme.spacing.unit}px center`,
    },
  },
  buttonsContainer: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 5,
  },
  button: {
    width: '100%',
    minWidth: 120,
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
  },
  resultsHeading: {
    marginBottom: theme.spacing.unit * 2,
  },
  noResultsContainer: {
    marginTop: theme.spacing.unit * 2,
  },
  paginatorContainer: {
    textAlign: 'center',
    marginTop: theme.spacing.unit * 5,
    marginBottom: theme.spacing.unit,
  },
  expansionPanel: {
    boxShadow: 'none',
  },
  expansionPanelTitle: {
    fontSize: '1.1875rem',
    width: '100%',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9375rem',
    },
  },
  expansionPanelDetails: {
    padding: `0 0 16px`,
    flexDirection: 'column',
  },
  expansionPanelContent: {
    fontSize: '1.1875rem',
    width: '100%',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    '& a': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9375rem',
    },
  },
  expandIcon: {
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
      borderRadius: '5px',
    },
  },
});

export default styles;
